"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useNotes;
var _react = require("react");
var _uuid = require("uuid");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function getLocalTimeZone() {
  if (typeof Intl !== "undefined") {
    try {
      return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (err) {
      return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
    }
  }
}
function useNotes() {
  var initialNotes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _useState = (0, _react.useState)(initialNotes),
    _useState2 = _slicedToArray(_useState, 2),
    notes = _useState2[0],
    setNotes = _useState2[1];
  (0, _react.useEffect)(function () {
    setNotes(initialNotes);
  }, [initialNotes]);
  var createNote = function createNote(payload) {
    var _payload$name = payload.name,
      name = _payload$name === void 0 ? "" : _payload$name,
      _payload$email = payload.email,
      email = _payload$email === void 0 ? "" : _payload$email,
      _payload$text = payload.text,
      text = _payload$text === void 0 ? "" : _payload$text;
    var nextNote = {
      id: (0, _uuid.v4)(),
      author: name,
      userEmail: email,
      text: text,
      date: Date.now(),
      timezone: getLocalTimeZone()
    };
    setNotes(function (prevNotes) {
      return [].concat(_toConsumableArray(prevNotes), [nextNote]);
    });
    return nextNote;
  };
  var deleteNoteById = function deleteNoteById(id) {
    setNotes(function (prevNotes) {
      return prevNotes.filter(function (note) {
        return note.id !== id;
      });
    });
  };
  var getNoteById = function getNoteById(id) {
    return notes.find(function (note) {
      return note.id === id;
    });
  };
  return {
    notes: notes,
    createNote: createNote,
    deleteNoteById: deleteNoteById,
    getNoteById: getNoteById
  };
}